var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-list"},_vm._l((_vm.allPosts),function(post,index){return _c('div',{key:index,staticClass:"post_details"},[(post.seo && post.seo.image)?_c('router-link',{attrs:{"to":{ 
        name: 'post',
        params: { 
          year: _vm.getDateObject(post.date).year,
          month: _vm.getDateObject(post.date).month,
          day: _vm.getDateObject(post.date).day,
          post: post.slug
        }
      }}},[_c('img',{attrs:{"src":post.seo.image.url}})]):_vm._e(),_c('h2',[_vm._v("\n        "+_vm._s(post.seo && post.seo.title ?
          post.seo.title
          :
          post.title)+" - \n        "),_c('router-link',{attrs:{"to":{ 
          name: 'post',
          params: { 
            year: _vm.getDateObject(post.date).year,
            month: _vm.getDateObject(post.date).month,
            day: _vm.getDateObject(post.date).day,
            post: post.slug
          }
        }}},[_vm._v("\n          details\n        ")])],1),(post.seo && post.seo.description)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.parsedDescription(post.seo.description))}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }